<div class="container-fluid g-0 m-0">
  <div class="d-flex g-0 m-0">
    <div class="sidemenu-nav background-color">
      <h6 class="sidemenu-title">{{ "GENERAL" | translate }}</h6>
      <div
        class="sidemenu-item-font item"
        (click)="navigate('settings/team/communication-management')"
        [ngClass]="{
          selected: isActive('settings/team/communication-management'),
        }"
      >
        <span>{{ "COMMUNICATION_MANAGEMENT" | translate }}</span>
      </div>
      @if(
      authService.isAuthorized([PermissionEnum.Settings_crud_region_view]) ||
      authService.isAuthorized([PermissionEnum.Settings_crud_area_view]) ||
      authService.isAuthorized([PermissionEnum.Settings_crud_assettype_view]) ||
      authService.isAuthorized([PermissionEnum.Settings_crud_metermake_view]) ||
      authService.isAuthorized([PermissionEnum.Settings_crud_metermodel_view]) ||
      authService.isAuthorized([PermissionEnum.Settings_crud_servicetype_view])
      ){
        <div
          class="sidemenu-item-font item"
          (click)="navigate('settings/crud/region')"
          [ngClass]="{ selected: isActive('/crud') }"
        >
          <span>CRUD</span>
        </div>
      }
      @if(authService.isAuthorized([PermissionEnum.Settings_team_member_view])){
        <div
          class="sidemenu-item-font item"
          (click)="navigate('settings/team/members')"
          [ngClass]="{ selected: isActive('/team') }"
        >
          <span>{{ "TEAM" | translate }}</span>
        </div>
      }
      @if(authService.isAuthorized([PermissionEnum.Scheduler_view])){
        <div
          class="sidemenu-item-font item"
          (click)="navigate('settings/scheduler/schedules')"
          [ngClass]="{ selected: isActive('/scheduler') }"
        >
          <span>{{"SCHEDULER" | translate}}</span>
        </div>
      }
      @if(authService.isAuthorized([PermissionEnum.Auditlog_view])){
        <div
          class="sidemenu-item-font item"
          (click)="navigate('settings/audit-logs')"
          [ngClass]="{ selected: isActive('/audit-logs') }"
        >
          <span>{{"AUDITLOGS" | translate}}</span>
        </div>
      }
    </div>

    <div class="sidemenu-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
